// @flow

const EXTENSION_URL_PATTERNS: $ReadOnlyArray<string> = [
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
];

function getStackString(error: mixed): string {
  if (!error || typeof error !== 'object') return '';

  // $FlowFixMe[prop-missing] - accessing stack from unknown error shape
  const stack = typeof error.stack === 'string' ? error.stack : '';
  // $FlowFixMe[prop-missing] - accessing cause from unknown error shape
  const cause = error.cause;
  const causeStack = cause && typeof cause === 'object' && typeof cause.stack === 'string'
    ? cause.stack
    : '';

  return stack + causeStack;
}

export function isBrowserExtensionError(error: mixed): boolean {
  const combinedStack = getStackString(error);
  return EXTENSION_URL_PATTERNS.some(pattern => combinedStack.includes(pattern));
}
